import { render, staticRenderFns } from "./picture-cmp.vue?vue&type=template&id=64ea716b"
import script from "./picture-cmp.vue?vue&type=script&lang=js"
export * from "./picture-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports